<div class="wrapper" *ngIf="!loading && canSeePage" [formGroup]="organizationFormGroup">
  <div>
    <div class="row gap center-children-vertically">
      <h1 class="cooper">{{ organization.name?.toUpperCase() }}</h1>
      <app-icon
        *ngxPermissionsExcept="'sherpa'"
        (click)="editName()"
        button
        type="edit"
      />
      <app-icon
        *ngxPermissionsOnly="'admin'"
        (click)="deleteOrganization()"
        type="trash"
        button
      ></app-icon>
    </div>
    <p>
      Organisation créée depuis le
      {{ organization.createdAt?.toLocaleDateString() }}
    </p>
  </div>

  <h2>Formule</h2>
  <div class="row gap center-children-vertically">
    <app-button 
      [disabled]="isPilot || hasManagedSubscription"
      [primary]="(subscriptionPlanMetadata$ | async)?.primary || false"
      [secondary]="(subscriptionPlanMetadata$ | async)?.secondary || false"
      [outline]="(subscriptionPlanMetadata$ | async)?.outline || false"
      [warning]="(subscriptionPlanMetadata$ | async)?.warning || false"
      [info]="(subscriptionPlanMetadata$ | async)?.info || false"
      [icon]="isPilot ? undefined : (subscriptionButtonIcon$ | async) || undefined"
      [dropdownTriggerFor]="dropdown"
      >
        {{ subscriptionButtonLabel$ | async }}
      </app-button>
      <app-dropdown #dropdown>
        <div class="dropdown-item" (click)="deletePlan()">
          <app-icon size="18" type="trash"></app-icon>
          <span>Supprimer</span>
        </div>
        <div *ngFor="let plan of plans" (click)="selectPlan(plan)" class="dropdown-item">
          {{ plan }}
        </div>
      </app-dropdown>
      
      <ng-container *ngxPermissionsOnly="'admin'">
        <div *ngIf="isTesterPlan$ | async" class="test-end-date-wrapper gap center-children-vertically">
          <app-input 
              title="Date de fin de test" 
              formControlName="testEndDate" 
              type="date"
            >
            </app-input>
            <div class="save-button">
              <app-icon
                (click)="modifyTestEndDate()"
                type="save"
                type="save"
                color="white"
                size="32"
              >
              </app-icon>
            </div>
        </div>
      </ng-container>
  </div>
  <app-info *ngIf="hasManagedSubscription">
    <p>Cette organisation utilise une souscription 2026. La formule legacy ci-dessus n'est plus modifiable.</p>
  </app-info>

  <ng-container *ngxPermissionsOnly="'admin'">
    <h3 class="managed-plan-panel__title">Souscription 2026</h3>
    <div class="managed-plan-panel">
      <div class="managed-plan-panel-copy">
        <p class="managed-plan-kicker">Optimiser votre offre</p>
        <h4>Comparez les offres 2026 avant de modifier l'organisation</h4>
        <p>
          Utilisez le comparatif pour choisir l'offre la plus adaptée à l'usage réel:
          activation des contenus, appel d'orientation offert et logique crédits plus simple.
        </p>
      </div>
      <div class="managed-plan-panel-actions">
        <app-button [primary]="true" type="button" (onClick)="goToCompanyOffers()">Comparer les offres</app-button>
      </div>
    </div>
    <app-info *ngIf="organization.activeSubscription as activeSubscription">
      <p>Offre active : {{ organization.subscriptionPlan?.name || activeSubscription.planCode }}</p>
      <p>Date de début : {{ activeSubscription.startsAt.toLocaleDateString() }}</p>
      <p>Fin d'abonnement : {{ activeSubscription.nextRenewalAt.toLocaleDateString() }}</p>
      <p>Collaborateurs contractuels : {{ activeSubscription.seatCount }}</p>
      <p *ngIf="organization.creditSummary">
        Crédits disponibles sur le cycle : {{ organization.creditSummary.cycleCreditsRemaining }} / {{ organization.creditSummary.cycleCreditsIncluded || organization.creditSummary.currentUnits }}
      </p>
    </app-info>
    <div class="managed-plan-summary-grid">
      <div class="managed-plan-summary-card" *ngIf="currentManagedOfferCard as currentOffer">
        <p class="managed-plan-kicker">Offre actuelle</p>
        <h4>{{ currentOffer.planCode === 'wetalk-plus' ? 'We talk Plus' : currentOffer.planCode === 'wetalk-coach' ? 'We talk coach' : 'We talk Basic' }}</h4>
        <p>{{ currentOffer.summary }}</p>
        <p class="managed-plan-credit">{{ currentOffer.creditSummary }}</p>
      </div>
      <div class="managed-plan-summary-card recommended" *ngIf="recommendedManagedOfferCard as recommendedOffer">
        <p class="managed-plan-kicker">Offre recommandée</p>
        <h4>{{ recommendedOffer.planCode === 'wetalk-plus' ? 'We talk Plus' : recommendedOffer.planCode === 'wetalk-coach' ? 'We talk coach' : 'We talk Basic' }}</h4>
        <p>{{ recommendedOffer.summary }}</p>
        <p class="managed-plan-credit">{{ recommendedOffer.creditSummary }}</p>
        <div class="managed-plan-highlights">
          <span *ngFor="let highlight of recommendedOffer.highlights">{{ highlight }}</span>
        </div>
      </div>
    </div>
    <div class="row gap center-children-vertically wrap">
      <app-input
        title="Offre 2026"
        [dropdownData]="managedFormulaNames"
        formControlName="managedSubscriptionPlan"
      ></app-input>
      <app-input
        title="Date de début"
        formControlName="managedSubscriptionStartsAt"
        type="date"
      ></app-input>
      <app-input
        title="Nombre de collaborateurs"
        formControlName="managedSubscriptionSeatCount"
        type="number"
        placeholder="1"
      ></app-input>
      <app-button
        [disabled]="!canSaveManagedSubscription"
        (click)="saveManagedSubscription()"
      >
        {{ managedSubscriptionActionLabel }}
      </app-button>
    </div>
  </ng-container>

  <h2>Pilotes</h2>

  <app-button icon="add" (click)="addPilot()">Ajouter un pilote</app-button>

  <br />
  <app-info *ngIf="organization.pilotAssociations">
    <p>
      Pour retirer des pilotes,
      <u class="pointer" (click)="goToQuestions()"
        >veuillez contacter votre partenaire We talk.</u
      >
    </p>
  </app-info>

  <div class="column pilots margin-top">
    <div
      class="pilot row gap"
      *ngFor="let association of organization.pilotAssociations"
    >
      <div class="flex-150 text-bold grow">
        {{ capitalize(association?.pilot?.lastName ?? "") }}
      </div>
      <div class="flex-150 text-bold grow">
        {{ capitalize(association?.pilot?.firstName ?? "") }}
      </div>
      <div class="flex-150">
        Pilote depuis le {{ association.createdAt.toLocaleDateString() }}
      </div>
    </div>
  </div>
  <h2>Thématiques</h2>
  <app-button icon="edit" (click)="editThematics()"
    >Gérer les thématiques</app-button
  >
  <div class="thematic-bloc row gap margin-top">
    <div class="tile">
      <div class="text-xl text-primary cooper">
        {{
          allThematics.length - (organization.forbiddenThematics?.length ?? 0)
        }}
      </div>
      <div class="cooper text-black">thématiques accessibles</div>
    </div>
    <div class="tile">
      <div class="text-xl text-secondary cooper">
        {{ organization.forbiddenThematics?.length ?? 0 }}
      </div>
      <div class="cooper text-black">thématiques bloquées</div>
    </div>
  </div>

  <div class="row gap center-children-vertically margin-top margin-bottom">
    <span>Dynamiques activées :</span>
    <app-checkbox formControlName="speechEnabled">
      Parole en groupe
    </app-checkbox>
    <app-checkbox formControlName="coachingEnabled">
      Coaching en groupe
    </app-checkbox>
  </div>

  <h2>Langue par défaut</h2>
  <p class="margin-bottom">
    Appliquée aux nouveaux collaborateurs. Chacun peut ensuite changer sa langue dans son profil.
  </p>
  <div class="row gap center-children-vertically margin-bottom">
    <select
      class="lang-select"
      formControlName="defaultLangId"
      [disabled]="isDisabled">
      <option value="">Français (défaut plateforme)</option>
      <option
        *ngFor="let lang of availableLangs"
        [value]="lang.id"
        [disabled]="!isUiLangEnabled(lang.name)">
        {{ getLangLabel(lang.name) }}
      </option>
    </select>
  </div>

  <h2>Gestion des crédits</h2>

  <div class="row gap center-children-vertically" *ngIf="canAddUnits">
    <p>Crédits disponibles : {{ units }}</p>
    <app-button [outline]="isPilot" (click)="editUnits()">{{ isPilot ? "Transférer des crédits" : "Ajouter des crédits" }}</app-button>
  </div>

  <div class="row gap center-children-vertically">
    <div class="column margin-bottom margin-top">
      <p class="text-bold">Quota par talker</p>
      <div class="half-width row gap center-children-vertically">
        <div class="quota-input-wrapper">
          <app-input
            formControlName="talkerQuota"
            [margin-bottom]="false"
            type="number"
            [dropdownData]="quotaPossibilities"
            (deleteClicked)="deleteQuota()"
          ></app-input>
        </div>
      </div>
    </div>
    <div class="column margin-bottom margin-top" *ngIf="!organizationFormGroup.controls.unlimitedQuota.value">
      <p class="text-bold">Tous les</p>
      <div class="half-width row gap center-children-vertically">
        <div class="width-150">
          <app-input
            formControlName="yearlyTalkerQuota"
            [margin-bottom]="false"
            [dropdownData]="quotaYearPossibilities"
            ></app-input>
        </div>
      </div>
    </div>
    <div class="margin-top">
      <app-checkbox formControlName="unlimitedQuota">Illimité</app-checkbox>
    </div>
  </div>

  <app-info>
    <ng-container *ngIf="hasUnlimitedCredits; else standardCreditsInfo">
      <p>Votre formule {{ subscriptionPlanName }} inclus les crédits illimités.</p>
    </ng-container>
    <ng-template #standardCreditsInfo>
      <p>{{ creditInfo.orientationCall.label }}</p>
      <p>{{ creditInfo.speechTrain.shortLabel }}</p>
      <p>{{ creditInfo.coachingTrain.shortLabel }}</p>
    </ng-template>
  </app-info>
  <div class="managed-plan-panel compact">
    <div class="managed-plan-panel-copy">
      <p class="managed-plan-kicker">Évolution d'offre</p>
      <p>
        Si cette organisation manque souvent de crédits ou a besoin de plus de contenus, comparez les offres 2026.
      </p>
    </div>
    <div class="managed-plan-panel-actions">
      <app-button [outline]="true" type="button" (onClick)="goToCompanyOffers()">Voir le comparatif</app-button>
    </div>
  </div>

  <h2>Modération des parcours</h2>
  <div class="column gap">
    <app-checkbox formControlName="extraOrganizationMatching"
      >Je souhaite que mes collaborateurs puissent rencontrer des collaborateurs
      d'autres organisations.
    </app-checkbox>
    <app-checkbox formControlName="intraOrganizationMatching"
      >Je souhaite que mes collaborateurs puissent se rencontrer lors des
      parcours.
    </app-checkbox>
  </div>
  <br />
  <app-info
    >Si vous décochez les deux cases ci-dessus, vos collaborateurs ne pourront
    rencontrer personne lors de leur parcours
  </app-info>

  <div *ngIf="forbiddenOrganizationsCheckboxes.length">
    <p class="margin-top margin-bottom">
      Je souhaite que mes collaborateurs ne puissent pas rencontrer des
      collaborateurs des organisations suivantes:
    </p>
    <app-checkmarks
      [checkboxes]="forbiddenOrganizationsCheckboxes"
      [isFemaleWord]="true"
      item-name="Organisation interdite"
      (changeSelection)="updateForbiddenOrganizationsSelection($event)"
    ></app-checkmarks>
  </div>

  <div *ngIf="organization.id">
    <h2>Organisations rattachées</h2>
    <app-button icon="add" (click)="addChild()"
      >Ajouter une organisation rattachée</app-button
    >

    <div class="organizations-list margin-top">
      <div
        class="organization-item row gap center-children-vertically"
        *ngFor="let organization of organization.children"
      >
        <div class="organization-icon center-children">
          <app-icon type="building" class="mobile-hidden" />
          <app-icon type="building" class="desktop-hidden" size="10" />
        </div>
        <p class="flex-200">{{ organization.name.toUpperCase() }}</p>
        <p class="flex-200">
          Créée le {{ organization.createdAt.toLocaleDateString() }}
        </p>
        <div class="row gap">
          <app-button
            (click)="switchOrganization(organization)"
            [outline]="true"
            icon="arrow-right"
            >Aller vers ce compte
          </app-button>
        </div>
      </div>
    </div>
    <div class="margin-top" *ngIf="!organization.children?.length">
      Aucune organisation n'est rattachée
    </div>
  </div>
</div>

<ng-container *ngIf="!canSeePage">
  <app-subscribe-page [height]="'85dvh'"></app-subscribe-page>
</ng-container>
